import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import withdraw_blue from '../../styles/assets/withdraw_blue.svg';
import { toast } from 'react-toastify';
import blue_tick from '../../styles/assets/blue_tick.svg';
import back from '../../styles/assets/back_arrow.svg';
import Spinner from "react-spinners/PuffLoader";

import { useLocation, useNavigate } from "react-router-dom";
import { getHypervergeKey,
         updateHypervergeStatus } from "../../services/backendHelpers";

const Container = styled.div`
    display: flex;
    
    height: 100vh;
    flex-direction: column;
    padding: 16px;
    background: rgba(14, 15, 24, 1);
`;

const BackTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 16px;
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(74, 125, 255, 0.04);
    border-radius: 40px;
    width: 84px;
    height: 84px;
`;

const SecurityWrapper = styled.div`
    background: #1C2A4C;
    padding: 14px 22px;
    text-align: left;
    color: #fff;
    border-radius: 8px;
    display: flex;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
`;


const Title = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
`;

const SubTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #7A7F9E;
`;

const BlueButton = styled.div<{ inActive: boolean }>`
  background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16.2526px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.101579px;
  color: #fff;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  cursor: ${({ inActive }) => (inActive ? 'not-allowed' : 'pointer')};
  opacity: ${({ inActive }) => (inActive ? '0.7' : '1')};
  pointer-events: ${({ inActive }) => (inActive ? 'none' : 'auto')};

`;


function RazorpayOffRampVerifyComponent(props:any){    
    const navigate: any = useNavigate();
    const [hypervergeData, setHypervergeData] = useState(null as any);
    const [showLoader, setShowLoader] = useState(false);
    
    const loadHypervergeKey = async ()=>{
        let hypervergeKey = await getHypervergeKey({});
        setHypervergeData(hypervergeKey);
    }
    useEffect(()=>{
        loadHypervergeKey();
    },[]);

    const handler = async (HyperKycResult:any) => {
        console.log('HyperKycResult', HyperKycResult);
        setShowLoader(true);
        let hypervergeStatus = HyperKycResult.status;
        setTimeout(async ()=>{
            hypervergeStatus = await updateHypervergeStatus({});
            console.log('legend aman', hypervergeStatus);
            switch(hypervergeStatus) {
                case "user_cancelled":
                    toast.error('Please complete KYC to do transactions');
                    // user cancelled
                    break;
                case "error":
                    // failure
                    toast.error('Error, try again');
                    break;
                case "auto_approved":
                    toast.success('KYC completed');
                    
                    break;
                case "auto_declined":
                    toast.error('Declined, try again');
                    break;
                case "needs_review":
                    toast.error('In review, will be completed by today');
                    // workflow success
                    break;
            }
            await props.refetchStatus();
            setShowLoader(false);
        }, 5000);
    }
    
    const handleKycClick = () => {
        const hyperKycConfig = new (window as any).HyperKycConfig(
            hypervergeData.token, 'workflow_tY2IGyV',
            hypervergeData.userId);
        (window as any).HyperKYCModule.launch(
            hyperKycConfig, handler);
    };
    
    const goBack = () => {
        navigate(-1);
    };

    if(!hypervergeData){
        return (
            <div style={{
                marginTop: 28,
                height:'100%',
                display:'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
              <Spinner  size={300} color="#ffffff" />
            </div>
        );
    }
    
    if(showLoader){
        return (
            <div style={{
                marginTop: 28,
                height:'100%',
                display:'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection:'column'
            }}>
              <Title style={{marginBottom:80}}>Verifying...</Title>
              <Spinner  size={300} color="#ffffff" />
            </div>
        );
    }

    let titleText = "Verify your identity";
    let subTitleText= "You will need to go through a KYC process in order to withdraw your money.";
    let buttonText = "Verify Identity";
    let buttonActive = true;
    
    if(props.userVerificationState == 'needs_review'){
        titleText= 'In verification'
        subTitleText= "Please wait for 24 hours.";
        buttonText = 'Please wait'
        buttonActive = false;
    }
    
    if(props.userVerificationState == 'auto_declined' ||
       props.userVerificationState == 'manually_declined'
    ){
        titleText= 'Try KYC again'
        subTitleText= "Document Could not be verified.";
        buttonText = 'Try again'
        buttonActive = true;
    }
    
    return (
        <Container>
          <div onClick={() => goBack()} style={{position: 'absolute', top: 0, left: 20}}>
            <img style={{position: 'absolute', top: 20}} src={back} alt='back arrow' className='hover'/>
            <BackTitle className='hover' style={{display: 'flex', justifyContent: 'center', marginTop: 16, marginLeft: 30}}>
              Withdraw
            </BackTitle>
          </div>
          <FlexContainer>
            <IconWrapper>
              <img src={withdraw_blue} />
            </IconWrapper>
            <Title style={{marginTop: 54}}>{titleText}</Title>
            <SubTitle style={{marginTop: 16}}>{subTitleText}</SubTitle>
            
          </FlexContainer>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <SecurityWrapper>
              <img src={blue_tick} />
              <span style={{marginLeft: 22}}>This process is secured by 256-bit security protocols.</span>
            </SecurityWrapper>
            <BlueButton inActive={!buttonActive} className='hover' onClick={handleKycClick} style={{marginTop: 16}}>{buttonText}</BlueButton>
          </div>
        </Container>
    )
}
export default RazorpayOffRampVerifyComponent;
